import { enumToList } from '..';
import { Pipe, PipeTransform } from '@angular/core';
import { QuizResponseType } from '../../enums/quiz-response-type.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'quizResponseType',
  standalone: false
})
export class QuizResponseTypePipe implements PipeTransform {
  public transform(value: QuizResponseType): string {
    return getQuizResponseType(value);
  }
}

export function getQuizResponseType(value: QuizResponseType): string {
  switch (value) {
    case QuizResponseType.Initialize:
      return 'Initialize';
    case QuizResponseType.Submit:
      return 'Submit';
    case QuizResponseType.Accept:
      return 'Accept';
    case QuizResponseType.AcceptRetake:
      return 'Accept & Request Retake';
    default:
      throw new Error(`Unsupported value for QuizResponseType: ${value}.`);
  }
}

export function getQuizResponseTypeList(): IdName[] {
  return enumToList(QuizResponseType, getQuizResponseType).filter((x) => x.id > QuizResponseType.Submit);
}
